"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendHeartbeat = void 0;
const axios_1 = require("./axios");
const sendHeartbeat = async (url, logger) => {
    logger.info("Sending a heartbeat message", undefined, undefined, { url });
    const response = await (0, axios_1.axiosPost)(url);
    logger.info("Heartbeat sent", undefined, undefined, { response: response?.data });
    return response?.data;
};
exports.sendHeartbeat = sendHeartbeat;
//# sourceMappingURL=health.js.map